import { render } from "./AdminHeaderComponent.vue?vue&type=template&id=30ecc8a4"
import script from "./AdminHeaderComponent.vue?vue&type=script&lang=js"
export * from "./AdminHeaderComponent.vue?vue&type=script&lang=js"

import "./AdminHeaderComponent.vue?vue&type=style&index=0&id=30ecc8a4&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__